import React from 'react';
import { Tabs } from 'antd';
import { AuthContext } from 'components/Auth/Auth';
import ModalControllerNV from 'components/ModalControllerNV';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import _, { noop, isNil } from 'lodash';
import { useState, useContext } from 'react';
import { useQuery } from 'react-query';
import { getProcTaskInit } from 'services/workflow';
import TaskModal from './TaskModal';
import { PropThirdPartyResponse } from 'services/proposal';
import { FormInstance } from 'antd/lib';
import { ToolOutlined } from '@ant-design/icons';

export type TasksListPopoverProps = {
  tptype?: string;
  countcode?: string;
  tpid?: number;
  formTP?: FormInstance;
  mgid?: number;
  entityName: string;
  entityReference?: string;
  entityId: number;
  title?: string;
  titlewithName?: any;
  subentity?: string;
  subentityid?: number;
  onSuccess?: any;
  children?: React.ReactChild;
  dataCtr?: Array<PropThirdPartyResponse>;
  dataInput?: any;
  dataList?: any;
  action?: string;
  funcode: string;
  entityList?: Array<{ entityId: number }>;
  status?: string;
  statusdate?: string;
  requestedamount?: number;
  currcode?: string;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  clientName?: string;
  ctrid?: number;
  refetchProp?: any;
  onClose?: any;
  prcode?: string;
  wizardsteps?: boolean;
  refetch: () => void;
  width?: number;
  prcodeProps?: string;
  genericActions?: boolean;
  message?: string;
  brand?:string;
};

const TaskSButtonSFS = ({
  refetch,
  dataCtr,
  tptype,
  countcode,
  formTP,
  mgid,
  entityId,
  entityName,
  title,
  titlewithName,

  subentity,
  subentityid,
  entityReference,
  tpid,
  onSuccess = noop,
  dataInput,
  action,
  funcode,
  entityList,
  status,
  statusdate,
  requestedamount,
  currcode,
  parcode,
  parvalue,
  parvalueparent,
  clientName,
  ctrid,
  refetchProp,
  onClose,
  prcode,
  children,
  wizardsteps,
  width,
  dataList,
  prcodeProps,
  genericActions,
  message,
  brand,
  ...otherProps
}: TasksListPopoverProps) => {
  const { TabPane } = Tabs;
  const [visiblePopover, setVisiblePopover] = useState(false);
  const closePopover = () => setVisiblePopover(false);
  const { getComponentLabel } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);

  const {
    data = [],
    isLoading,
    isError,
  } = useQuery(
    [
      'getProcTaskInit',
      { entityId, entityName, funcode, action, prcode },
      refetchProp,
    ],
    () =>
      getProcTaskInit({
        entity: entityName,
        entityid: entityId,
        funcode: funcode,
        action: action ?? '',
        prcode: prcode ?? '',
      }).then((res) => res.list || [])
  );

  return (
    data?.length > 0 && (
      <div onClick={(e) => e.stopPropagation()}>
        <ModalControllerNV
          content={({ setVisible }) => (
            <>
              {isInspect && (
                <ToolOutlined
                  style={{ fontSize: 22 }}
                  onClick={() => setVisible(true)}
                />
              )}
              <div onClick={() => !isInspect && setVisible(true)}>
                {children}
              </div>
            </>
          )}
          modal={({ setVisible, visible }) => {
            const hideModal = () => setVisible(false);
            const handleSuccess = () => {
              if (refetch) refetch();
              if (onSuccess) onSuccess();
              // onSuccess(); // Call the original onSuccess logic
              hideModal(); // Close the modal
            };
            return (
              <TaskModal
                refetch={refetch}
                clientName={clientName}
                entityList={entityList}
                random={Math.round(_.random(10000) * 10000000)}
                entityId={entityId}
                entity={entityName}
                entityName={
                  !isNil(title) ? `${entityName} - ${title}` : entityName
                }
                subentity={data?.[0]?.subentity || ''}
                subentityid={data?.[0]?.subentityid || 0}
                onCancel={hideModal}
                onSuccess={handleSuccess}
                task={data?.[0] || {}}
                visible={visible}
                mgid={mgid}
                formTP={formTP}
                tptype={tptype}
                countcode={countcode}
                tpid={tpid || entityId}
                ctrid={ctrid}
                data={dataCtr}
                entityReference={entityReference}
                dataInput={dataInput}
                status={status}
                statusdate={statusdate}
                requestedamount={requestedamount}
                currcode={currcode}
                parcode={parcode}
                parvalue={parvalue}
                parvalueparent={parvalueparent}
                title={title}
                titlewithName={titlewithName}
                wizardsteps={wizardsteps}
                width={width ?? 560}
                dataList={dataList}
                prcodeProps={prcodeProps}
                genericActions={genericActions}
                message={message}
                brand={brand}
              />
            );
          }}
        />
      </div>
    )
  );
};

export default TaskSButtonSFS;
